const faqs = [
  {
    question: "Does Kentucky have its own regional passport agency?",
    answer:
      "Kentucky does not have a state-level regional passport agency. The nearest facilities for most Kentucky travelers are the Chicago Passport Agency in Illinois and the Atlanta Passport Agency in Georgia. Northern Kentucky residents may also consider the Detroit Passport Agency depending on appointment availability.",
  },
  {
    question: "How fast can I get a passport in Kentucky?",
    answer:
      "With Fast Passport Center's courier service, Kentucky travelers can receive a passport in as little as 24 hours. Our standard expedited service ranges from 3 to 9 business days. Routine processing through the post office typically takes 6 to 13 weeks.",
  },
  {
    question: "Do I need to visit a passport acceptance facility in Kentucky?",
    answer:
      "First-time applicants, minors, and those replacing lost or stolen passports must visit an acceptance facility (typically a post office, county clerk, or library). Renewals for adults can usually be done by mail without an in-person visit.",
  },
  {
    question: "Which Kentucky airport should I fly from with an expired passport?",
    answer:
      "If your passport is expired or soon to expire, you should not book international travel until you have a valid passport in hand. Major Kentucky international departure points include Cincinnati/Northern Kentucky International Airport (CVG), Louisville Muhammad Ali International (SDF), and Blue Grass Airport in Lexington (LEX).",
  },
  {
    question: "Can I renew my passport by mail from Kentucky?",
    answer:
      "Yes, if your most recent passport was issued when you were age 16 or older, was issued within the last 15 years, is undamaged, and was issued in your current name (or you have legal documentation of a name change), you can renew by mail using Form DS-82 from anywhere in Kentucky.",
  },
  {
    question: "Where is the best place to get a passport photo in Kentucky?",
    answer:
      "CVS Pharmacy, Walgreens, and Walmart photo centers are widely available across Kentucky in Louisville, Lexington, Bowling Green, and Northern Kentucky. UPS Store and FedEx Office locations also offer passport photos and can overnight ship your documents. Always verify the photo meets the 2×2 inch, white-background requirement.",
  },
];

export { faqs };

export default function KentuckyFAQSection() {
  return (
    <section id="faq" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">FAQ</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Kentucky Passport Questions
          </h2>
          <p className="text-gray-500 text-base leading-relaxed">
            Quick answers for travelers applying for passports across the Commonwealth of Kentucky.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, i) => (
            <details
              key={i}
              className="group bg-white rounded-lg border border-gray-200 overflow-hidden"
            >
              <summary className="flex items-center justify-between cursor-pointer p-5 list-none">
                <span className="font-bold text-[#1A365D] text-sm pr-4">{faq.question}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                  <i className="ri-add-line text-[#1A365D] text-sm group-open:ri-subtract-line"></i>
                </div>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-gray-500 text-sm leading-relaxed">{faq.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}